import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ReturnOptionProps } from '../../../../../../../types/ProductFactory';
import SearchSelectInputV2 from '../../../../../../common/src/components/SearchSelectInputV2';
import QuestionGroupActions from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupActions';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import useQuestionEnum from '../../../../hooks/useQuestionEnum';
import AdvisoryFlowMainContainer from '../../../ui/advisory-flow/components/app-shell/AdvisoryFlowMainContainer';
import QuestionGroupAssistantQuestion from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupAssistantQuestion';
import QuestionGroupBody from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupBody';
import QuestionGroupSubViewWrapper from '../../../ui/advisory-flow/components/question-group-components/QuestionGroupSubViewWrapper';

interface Props {
  isMobile?: boolean;
  language: string;
  legalLanguageQuestion: FlowsQuestion;
  previousSubView: () => void;
  nextQuestionHandler: () => void;
  handleChange: (arg0: string) => void;
}

const CbeLanguage: React.FC<React.PropsWithChildren<Props>> = ({
  language,
  legalLanguageQuestion,
  previousSubView,
  nextQuestionHandler,
  handleChange,
}) => {
  const { t } = useTranslation();

  const Question = () => (
    <QuestionGroupAssistantQuestion
      question={t('What is the native language of the company?')}
      description={t('If you do not know, you can skip this question')}
    />
  );

  const enumOptions = useQuestionEnum(legalLanguageQuestion);

  const handleOnChange = ({ value }: ReturnOptionProps) => {
    handleChange(value as string);
  };

  return (
    <AdvisoryFlowMainContainer data-test-id="ProdFac_CbeLanguage">
      <Question />
      <QuestionGroupBody>
        <QuestionGroupSubViewWrapper>
          <SearchSelect
            placeholder={t('Choose an option')}
            name="company.language"
            onSelected={handleOnChange}
            options={enumOptions}
            value={enumOptions.find(({ value }) => language === value)}
            dataTestId="ProdFac_SelectInputComponent"
            menuPlacement="auto"
          />
        </QuestionGroupSubViewWrapper>
      </QuestionGroupBody>
      <QuestionGroupActions
        onBack={previousSubView}
        onContinue={nextQuestionHandler}
      />
    </AdvisoryFlowMainContainer>
  );
};

const SearchSelect = styled(SearchSelectInputV2)`
  width: 100%;
  max-width: 45rem;
  height: unset;
  align-self: center;

  label > div {
    border-radius: 6px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06),
      0 0 1px rgba(0, 0, 0, 0.04);
    margin-bottom: 0;
    margin-top: 0;
  }
`;

export default CbeLanguage;
